'use strict';
'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as Action from '@redux/action/detail';

import LazyLoad from 'react-lazyload';
import throttle from 'lodash.throttle';
import {StickyDecorator} from '@component/sticky';
import Notice from '@component/notice';
import ReactSwipe from 'react-swipe';
import classNames from 'classnames';
import KNB from '@dp/knb';
import Share from '@dp/util-m-share';
import Toast from '@dp/wepp-module-toast';
import Login from '@dp/util-login';
import Util from '@common/js/util';
import { formatDate as FormatDate } from '@common/js/date_format';
import {shareSuccHandler as ShareCB} from '@common/js/share_cb';
import style from './assets/styles/detail.less.module';
import '@common/css/page_loading.less';

const MAXPRELOADHEIGHT = 50;

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cursor: 0
        }
    }

    componentDidMount() {
        let swipeImgInit = document.getElementsByClassName('swipe-img-init')[0]
        // dpapp在IOS环境中图片上有translateZ属性，图片显示会有问题
        if (swipeImgInit) {
            const url = swipeImgInit.getAttribute('data-url');
            if (!url) return;
            swipeImgInit.setAttribute('src', url);
            swipeImgInit.removeAttribute('data-url');
        }
    }

    render(HeadData = this.props) {
        return (
            <header>
                {
                    HeadData.headImgList && (
                        <div className={style["img_wrap"]}>
                            <ReactSwipe swipeOptions={{
                                continuous: false,
                                callback: (index, elem) => {
                                    const url = elem.getAttribute('data-url');
                                    this.setState({
                                        cursor: index
                                    })
                                    if (!url) return;
                                    elem.setAttribute('src', url);
                                    elem.removeAttribute('data-url');
                                }
                            }} style={{
                                container: {position: 'relative', height: '28.1rem', overflow: 'hidden'},
                                wrapper: {position: 'relative', height:`100%`},
                                child: {float:`left`, position: `relative`, width:`100%`, height:`100%`}
                            }}>
                                {
                                    HeadData.headImgList.map((item, index) => {
                                        return (
                                            index ? (<img data-url={item} src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" key={index}/>) : (
                                                <img className="swipe-img-init" data-url={item} src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" key={index}/>
                                            )
                                        )
                                    })
                                }
                            </ReactSwipe>
                            <div className={style["img_count"]}>
                                {
                                    HeadData.headImgList.length > 1 && HeadData.headImgList.map((item, index) => {
                                        return <i className={classNames({
                                            [style["count_dot"]]: true,
                                            [style["count_dot_on"]]: this.state.cursor == index
                                        })} key={index}></i>
                                    })
                                }
                            </div>
                        </div>
                    )
                }
                <div className={style["desc_wrap"]}>
                    <p className={style["desc_hd"]}>{HeadData.title}</p>
                    <div className={style["desc_info"]}>
                        {
                            HeadData.mode == 11 ? (
                                <p>
                                    起拍价<span className={style["highlight"]}>{HeadData.startPrice}D币</span>
                                </p>
                            ) : (
                                <p>
                                    <span className={style["highlight"]}>￥</span><span className={style["cur_price"]}>0</span>
                                    <span className={style["origin_price"]}>￥<del>{HeadData.cost}</del></span>
                                </p>
                            )
                        }
                        {
                            HeadData.mode == 11 ? (
                                <p className={style["statistics"]}>
                                    <span className={style["statistics_item"]}>{FormatDate(HeadData.applyEndTime, 'MM月dd日 HH:mm')}截止</span>
                                </p>
                            ) : HeadData.mode == 13 ? (
                                <p className={style["statistics"]}>
                                    <span className={style["statistics_item"]}>名额<el className={style["highlight"]}>{HeadData.joinCount || '不受限制'}</el></span>
                                    <span className={style["statistics_item"]}>{HeadData.applyCount}人次抽</span>
                                    <span className={style["statistics_item"]}>{HeadData.userWinCount}人已中</span>
                                </p>
                            ) : (
                                <p className={style["statistics"]}>
                                    <span className={style["statistics_item"]}>名额<el className={style["highlight"]}>{HeadData.joinCount || '不受限制'}</el></span>
                                    <span className={style["statistics_item"]}>{HeadData.applyCount}人报名</span>
                                </p>
                            )
                        }
                    </div>
                    {
                        HeadData.passCount > 0 ? (
                            <p className={classNames({
                                [style["passcard"]]: true,
                                [style["passcard_disabled"]]: !HeadData.leftPassCount,
                            })}>
                                {HeadData.leftPassCount ? '支持使用Pass卡，' : 'Pass卡名额已用完，'}
                                <a className="passcard_link" href={Util.getDomain() + "/mobile/event/passCardQA"}>什么是Pass卡</a>
                            </p>
                        ) : null
                    }
                </div>
                {
                    HeadData.mode == 11 ? <Record list={HeadData.recordVOs || []} offlineActivityId={HeadData.offlineActivityId}/> : HeadData.mode == 13 ? (
                        <p className={style["desc_tips"]}>结果立刻揭晓，抽不中还有霸气值送哦</p>
                    ) : null
                }
            </header>
        )
    }
}

class Record extends React.Component {
    constructor(props) {
        super(props);
    }

    render( { list, offlineActivityId } = this.props ) {
        return list.length ? (
            <div className={style["record_wrap"]}>
                <a className={style["record_title"]} href="javascript:;"
                    onClick={() => {
                        location.href = `${Util.getDomain()}/mobile/event/${offlineActivityId}/auctionRecord?token=*`
                    }}
                >拍卖纪录<span className={style["icon_arrow"]}></span></a>
                <ul className={style["record_list"]}>
                    {
                        list.map((item, index) => {
                            return (
                                <li className={classNames({
                                    [style["record_item"]]: true,
                                    [style["record_disable_item"]]: item.out
                                })} key={index}>
                                    <label className={style["label_status"]}>{item.des}</label>
                                    <span className={style["record_username"]}>{item.nickName}</span>
                                    <span className={style["record_time"]}>{FormatDate(item.time, 'MM.dd HH:mm', '.')}</span>
                                    <span className={style["record_price"]}>{item.price}</span>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        ) : null
    }
}

class Shop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cursor: 0 // 记录列表展示索引
        }
        this.switchShop = this.switchShop.bind(this);
    }

    render({list = []} = this.props) {
        let item = list[this.state.cursor];
        return (
            <div className={style["shop_wrap"]}>
                <p className={style["shop_title"]}>
                    适用商户{list.length > 1 && `(${list.length})`}
                    {list.length > 1 && <span className={style["shop_change"]} onClick={this.switchShop}>换一换</span>}
                </p>
                {item ? (<div className={style["shop_content"]}>
                    <a className={style["shop_detail"]} href="javascript:;" onClick={() => {
                        LXAnalytics('moduleClick', 'b_y718vrmf')
                        if (!Util.shareRedirect()) return;
                        location.href = item.shopJumpUrl;
                        }}>
                        <p className={style["shop_brand"]}>{item.shopFullName}</p>
                        <p className={style["shop_info"]}>
                            <i className={classNames({
                                [style["start_level"]]: true,
                                [style[`start_${item.shopPower}`]]: true
                            })}></i>
                            <span className={style["distance"]}>{item.distanceInfo}</span>
                        </p>
                    </a>
                    {
                        item.phoneNo && (Util.shareRedirect(true) ? (<a className={style["shop_phone"]} href={`tel:${item.phoneNo}`}></a>) : (
                            <a className={style["shop_phone"]} href="javascript:;" onClick={() => {
                                if (!Util.shareRedirect()) return;
                            }}></a>
                        ))
                    }
                </div>) : ''}
                {item ? (<p className={style["shop_loc"]} onClick={() => {
                    LXAnalytics('moduleClick', 'b_y718vrmf');
                    if (!Util.shareRedirect()) return;
                    location.href = item.shopJumpUrl;
                }}>{item.shopAddress}</p>) : ''}
            </div>
        )
    }
    switchShop() {
        const {length} = this.props.list
        if(!length) return;
        if (!Util.shareRedirect()) return;
        this.setState({
            cursor: (this.state.cursor + 1) % length
        });
    }
}

class Nav extends React.Component {
    constructor(props) {
        super(props);
    }
    
    render({NavData, navHandle} = this.props) {
        const {staticData = [], navCursor: cursor } = NavData;
        return (
            <nav className={style["tab_wrap"]}>
                {
                    staticData.map((item) => {
                        return <span key={item.id} className={classNames({
                            [style["tab_item"]]: true,
                            [style["tab_item_on"]]: cursor == item.id
                        })} onClick={navHandle} data-id={item.id}>{item.name}</span>
                    })
                }
            </nav>
        )
    }
}

class Detail extends React.Component {
    constructor(props) {
        super(props);
        this.StickyFooter = StickyDecorator(Footer);
        this.state = {
            unfold: false // 展开
        };
        this.toggleMechtModule = this.toggleMechtModule.bind(this);
    }

    render({ DetailData, UserData, isHidden, fetchUserData } = this.props) {
        return (
            <section className={classNames({
                [style["detail_container"]]: true,
                [style["hide"]]: isHidden
            })}>
                {/*TODO: 类型1 default */}
                <div>
                    <p className={style["detail_title"]}>活动详情</p>
                    {
                        !DetailData.newActivity && DetailData.body ? <div className={style["detail_content"]} dangerouslySetInnerHTML={{__html: DetailData.body}}></div>
                        : (
                            <ul className={style["detail_content"]}>
                                {
                                    DetailData.activityContent.map((tip, index) => {
                                        return <li key={index}>{tip}</li>
                                    })
                                }
                            </ul>
                        )
                    }
                </div>

                {/*TODO: 类型5 more_entry, 缺省数据*/}
                <a className={style["more_entry"]}
                    href="javascript:;"
                    onClick={() => {
                        LXAnalytics('moduleClick', 'b_cog4xrfy')
                        if (!Util.shareRedirect()) return;
                        location.href = `${Util.getDomain()}/mobile/event/detailWithPic/${DetailData.offlineActivityId}`
                    }}
                >更多图文详情</a>

                {
                    DetailData.scenicSpotIntroduction ?
                    (
                        <div>
                            <p className={style["detail_title"]}>景区介绍</p>
                            <div className={style["detail_content"]} dangerouslySetInnerHTML={{__html: DetailData.scenicSpotIntroduction}}></div>
                        </div>
                    ) : ''
                }

                <div>
                    <p className={style["detail_title"]}>活动可用时间</p>
                    <div className={style["detail_content"]}>{FormatDate(DetailData.beginTime, 'yyyy年MM月dd日 HH:mm')} - {FormatDate(DetailData.endTime, 'yyyy年MM月dd日 HH:mm')}</div>
                </div>
                <div>
                    <p className={style["detail_title"]}>活动说明</p>
                    <ul className={style["detail_content"]}>
                        {
                            DetailData.activityExplain.map((tip, index) => {
                                return <li key={index}>{tip}</li>
                            })
                        }
                    </ul>
                </div>

                {/*TODO: 类型2 list */}
                <div>
                    <p className={style["detail_title"]}>预约信息</p>
                    {
                        DetailData.appointmentFlag ? (
                            <div className={style["detail_content"]}>
                                1.需提前{DetailData.earlierDays}天预约<br/>2.预约电话：{DetailData.appointmentPhone}
                            </div>
                        ) : <div className={style["detail_content"]}>不需要预约</div>
                    }
                </div>

                {
                    DetailData.kindTips ? (
                        <div>
                            <p className={style["detail_title"]}>温馨提示</p>
                            <ul className={style["detail_content"]}>
                                {
                                    DetailData.kindTips.map((tip, index) => {
                                        return <li key={index}>{tip}</li>
                                    })
                                }
                            </ul>
                        </div>
                    ) : null
                }
                
                {
                    DetailData.mode != 11 && (
                        <div>
                            <p className={style["detail_title"]}>中奖小窍门</p>
                            <ul className={style["detail_content"]}>
                                {
                                    DetailData.winTips.map((tip, index) => {
                                        return <li key={index}>{tip}</li>
                                    })
                                }
                            </ul>
                        </div>
                    )
                }
                <div>
                    <p className={style["detail_title"]}>活动Tips</p>
                    {
                        !DetailData.newActivity && DetailData.desc ? <div className={style["detail_content"]} dangerouslySetInnerHTML={{__html: DetailData.desc}}></div> // 说明：老版本使用富文本编辑器，自带DOM结构
                        : (
                            <ul className={style["detail_content"]}>
                                {
                                    DetailData.activityTips.map((tip, index) => {
                                        return <li key={index}>{tip}</li>
                                    })
                                }
                            </ul>
                        )
                    }
                </div>

                {
                    (!!DetailData.releasedUsersCount && !!UserData.list.length) && (
                        <div>
                            <p className={style["detail_title"]}>中奖名单</p>
                            <div className={classNames({
                                [style["detail_content"]]: true,
                                [style["red_txt"]]: true
                            })}>
                                {UserData.list.join(', ')}
                                {
                                    !UserData.isEnd && !UserData.isError && <p className={style["more_user"]} onClick={fetchUserData}>更多</p>
                                }
                            </div>
                        </div>
                    )
                }

                <div className={style["merchant_wrap"]}>
                    <p className={style["merchant_title"]} onClick={this.toggleMechtModule}>
                        我是商家，三步让门店人气暴增
                        <label className={style["merchant_label"]}>商家</label>
                        <i className={classNames({
                            [style["icon_arrow_down"]]: !this.state.unfold,
                            [style["icon_arrow_up"]]: this.state.unfold,
                        })}></i>
                    </p>
                    <div className={classNames({
                        [style["merchant_content"]]: true,
                        [style["hide"]]: !this.state.unfold
                    })}>
                        <ul className={style["merchant_list"]}>
                            <li className={style["merchant_item"]}>
                                <p className={style["merchant_item_title"]}>关注</p>
                                <div className={style["merchant_item_desc"]}>
                                    曝光增加
                                    <p className={style["merchant_item_desc_highlight"]}>500%</p>
                                </div>
                            </li>
                            <li className={style["merchant_item"]}>
                                <p className={style["merchant_item_title"]}>到店</p>
                                <div className={style["merchant_item_desc"]}>
                                    客流提升
                                    <p className={style["merchant_item_desc_highlight"]}>50%</p>
                                </div>
                            </li>
                            <li className={style["merchant_item"]}>
                                <p className={style["merchant_item_title"]}>口碑</p>
                                <div className={style["merchant_item_desc"]}>
                                    优质评价
                                    <p className={style["merchant_item_desc_highlight"]}>150%</p>
                                </div>
                            </li>
                        </ul>
                        <p className={style["merchant_tips"]}>下载点评管家APP，1分钟完成入驻</p>
                        <div className={style["btn_wrap"]}>
                            <a href={Util.getDomain(true) + "/platform/record/index.html"} className={classNames({
                                [style["btn"]]: true,
                                [style["btn_plain"]]: true
                            })}>了解更多</a>
                            <a href="//e.dianping.com/mobile/viewDpgj" className={classNames({
                                [style["btn"]]: true,
                                [style["btn_primary"]]: true
                            })}>立即入驻</a>
                        </div>
                    </div>
                </div>

                {/*<this.StickyFooter btnOpt={{
                    text: this.btnText[DetailData.userApplyStatus],
                    handle: this.btnClickHandle
                }} bottomOffset={0} setSticky={!isHidden}/>*/}
            </section>
        )
    }

    toggleMechtModule() {
        if (!Util.shareRedirect()) return;
        this.setState({
            unfold: !this.state.unfold
        });
        // 说明：强行将父容器滚动上去(已知父容器可滚动(⊙﹏⊙)b)
        if (!this.state.unfold) {
            setTimeout(() => { // 降低优先级
                let parentNode = ReactDOM.findDOMNode(this).parentNode;
                parentNode.scrollTop = parentNode.scrollHeight
            }, 0)
        }
    }
}

class Response extends React.Component {
    constructor(props) {
        super(props);
        this.StickyFooter = StickyDecorator(Footer);
    }
    render( { ResData, isHidden, inputHidden = true, resAction } = this.props) {
        const { list = [], loading, isEnd, isError, page, errMsg, endMsg } = ResData
        return (
            <ul className={classNames({
                [style["response_container"]]: true,
                [style["hide"]]: isHidden
            })}>
                {
                    list.map((item, index) => {
                        return (
                            <li className={style["res_item"]} key={index}>
                                <div className={style["avatar_wrap"]}>
                                    <LazyLoad once height={"4rem"} offset={50}>
                                        <img className={style["avatar"]} src={item.userFace}/>
                                    </LazyLoad>
                                </div>
                                <div className={style["res_info"]}>
                                    <p className={style["user_date"]}>
                                        <span className={style["username"]}>{item.userNickName}</span>
                                        <span className={style["timestamp"]}>{item.addDate}</span>
                                    </p>
                                    <p className={style["content"]}>{item.noteBody}</p>
                                </div>
                            </li>
                        )
                    })
                }
                {
                    loading && <div className={style["load_wrap"]}><i className={style["icon_loading"]}></i></div>
                }
                {
                    (isError || isEnd) && <p className={style["list_tips"]}>{isError ? errMsg : endMsg}</p>
                }
                {/*{
                    inputHidden && <this.StickyFooter btnOpt={{
                        text: '我要回应',
                        handle: (e) => {
                            e.preventDefault();
                            resAction();
                        }
                    }} bottomOffset={0} setSticky={!isHidden}/>
                }*/}
            </ul>
        )
    }
}

class Footer extends React.Component {
    constructor(props) {
        super(props);
    }
    render({positionStyle, btnOpt} = this.props) {
        return (
            <footer className={classNames({
                [style["footer_wrap"]]: true,
                [style["btn_wrap"]]: true
            })} style={positionStyle}>
                <a className={classNames({
                    [style["btn"]]: true,
                    [style["btn_primary"]]: true
                })} href="javascript:;" onClick={btnOpt.handle}>{btnOpt.text}</a>
            </footer>
        )
    }
}

class Input extends React.Component {
    constructor(props) {
        super(props);
        console.log('input init');
    }
    render({focusEvt, blurEvt, getInputRef, resSubmit, isHidden} = this.props) {
        return (
            <form className={classNames({
                [style["input_wrap"]]: true,
                [style["Hide"]]: isHidden
            })} onSubmit={resSubmit}>
                <input className={style["input_el"]} onFocus={focusEvt} onBlur={blurEvt} ref={getInputRef}/>
                <button className={classNames({
                    [style["btn"]]: true,
                    [style["btn_plain"]]: true,
                    [style["btn_res_submit"]]: true,
                })} type="submit">提交</button>
            </form>
        )
    }
}

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputHidden: true // 保存`input`状态
        }
        this.offlineActivityId = Util.parseQuery('offlineActivityId'); // TODO: url query !!!
        this.btnText = ['我要报名', '已报名,看看其他活动', '已结束,看看其他活动', '已中奖,看看其他活动', '立即拍', '立即抽', '明天再来，看看其它活动','继续抽奖', '邀请好友']
        this.initData();
        this.stickyNotice = StickyDecorator(Notice);
        this.StickyFooter = StickyDecorator(Footer);
        this.navHandle = this.navHandle.bind(this);
        this.fetchResponseData = this.fetchResponseData.bind(this);
        this.scrollLoadHandle = this.scrollLoadHandle.bind(this);
        this.btnClickHandle = this.btnClickHandle.bind(this);
        this.inputStatusToggle = this.inputStatusToggle.bind(this);
        this.inputFocusEvt = this.inputFocusEvt.bind(this);
        this.inputBlurEvt = this.inputBlurEvt.bind(this);
        this.inputSubmitHandle = this.inputSubmitHandle.bind(this);
        this.fetchUserData = this.fetchUserData.bind(this);
        this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    }

    componentDidMount() {
        this.scrollContainer && this.scrollContainer.addEventListener('scroll', this._scrollLoadHandler = throttle(this.scrollLoadHandle, 50));
    }

    componentWillReceiveProps(nextprops) {
        if (!this._scrollLoadHandler) {
            this._scrollLoadHandler && this.scrollContainer.addEventListener('scroll', this._scrollLoadHandler = throttle(this.scrollLoadHandle, 50));
        }
    }

    render({ NavData, DetailData, ResData, UserData } = this.props) {
        let isVersion10 = Util.isVersion10();
        return DetailData.loading ? (
            <div className={isVersion10 ? "page_loading_v10" : "page_loading"}></div>
        ) : (
            <div className={style["detail_layout"]} style={{height: `${this.clientHeight}px`}}>
                {
                    !this.state.destoryNotice && DetailData.noticeInfoVO && DetailData.noticeInfoVO.noticeText && DetailData.noticeInfoVO.noticeText.trim() && (
                        <this.stickyNotice opt={{
                            LSKEY: DetailData.noticeInfoVO.noticeId,
                            defaultLS: true, // 默认存储LocalStorage
                            frequency: 1 // 1天
                        }} content={DetailData.noticeInfoVO.noticeText} clickHandle={(e) => {
                            e.preventDefault();
                            Util.handleRedir(DetailData.noticeInfoVO.noticeUrl || 'javascript:;')
                        }} closeHandle={(e) => {
                            if (!Util.shareRedirect()) return;
                            this.setState({
                                destoryNotice: true
                            })
                        }} topOffset={0} setSticky/>
                    )
                }
                <section className={style["detail_main"]} ref={container => this.scrollContainer = ReactDOM.findDOMNode(container)}>
                    <Header {...DetailData}></Header>
                    <Shop list={DetailData.activityShopInfoList || []}/>
                    <Nav NavData={NavData} navHandle={this.navHandle}></Nav>
                    <Detail
                        DetailData={DetailData}
                        UserData={UserData}
                        isHidden={ NavData.navCursor != NavData.staticData[0].id }
                        fetchUserData={this.fetchUserData}/>
                    <Response
                        ResData={ResData}
                        isHidden={ NavData.navCursor != NavData.staticData[1].id }
                        inputHidden={this.state.inputHidden}
                        resAction={this.inputStatusToggle}/>
                </section>
                {
                    NavData.navCursor == NavData.staticData[0].id && <this.StickyFooter btnOpt={{
                        text: DetailData.mode == 11 && this.btnText[4] || DetailData.mode == 13 && !DetailData.userApplyStatus && this.btnText[5] || DetailData.mode == 13 && DetailData.userApplyStatus == 1 && this.btnText[6] || DetailData.mode == 13 && DetailData.userApplyStatus == 4 && this.btnText[7] || DetailData.mode == 13 && DetailData.userApplyStatus == 5 && this.btnText[8]||this.btnText[DetailData.userApplyStatus],
                        handle: this.btnClickHandle
                    }} bottomOffset={0} setSticky/>
                }
                {
                    NavData.navCursor == NavData.staticData[1].id && this.state.inputHidden && <this.StickyFooter btnOpt={{
                        text: '我要回应',
                        handle: this.inputStatusToggle
                    }} bottomOffset={0} setSticky/>
                }
                <Input
                    resSubmit={this.inputSubmitHandle}
                    getInputRef={el => this.inputRef = ReactDOM.findDOMNode(el)}
                    focusEvt={this.inputFocusEvt}
                    blurEvt={this.inputBlurEvt}
                    isHidden={this.state.inputHidden}/>
            </div>
        )
    }

    initData() {
        const { fetchDetailData } = this.props;
        // 详情
        fetchDetailData('/activity/static/detail', {
            offlineActivityId: this.offlineActivityId
        }).then((r) => {
            if (window.performance) {
                try{
                    timeing = window.performance.timing.navigationStart;
                
                    Owl.addPoint({
                        position: 1,
                        duration: new Date() - timeing
                    });
                    Owl.sendPoints();
                }catch(e){
                    console.error(e)
                }
            }
            // 重置标题
            this.resetTitle(r.data.detail.title);
            // 获取用户名单
            !!r.data.detail.releasedUsersCount && this.fetchUserData();
            let shareInfo = r.data.detail.shareInfo;
            shareInfo && new Share({
                title: shareInfo.shareTitle,
                desc: shareInfo.shareDesc,
                url: shareInfo.shareUrl,
                image: shareInfo.sharePic,
                content: shareInfo.shareDesc,
                channelDPApp: [Share.CHANNEL.WECHAT_FRIENDS,Share.CHANNEL.WECHAT_TIMELINE],
                channelWX: [Share.CHANNEL.WECHAT_FRIENDS,Share.CHANNEL.WECHAT_TIMELINE],
                success: () => {
                    ShareCB().then((r) => {
                        let addScore = r.msg.score
                        parseInt(addScore) && Toast(`分享成功，又增加了${addScore}霸气值`)
                    }).catch((e) => {
                        console.log('Exception', e);
                    })
                }
            })
        }).catch((e) => {
            console.log('Exception', e);
        });
    }

    resetTitle(title) {
        if (!title) return;
        if (Util.isApp()) {
            KNB.setTitle({
                title: title,  //标题
            });
        } else {
            document.title = title;
        }
    }

    navHandle(e) {
        e.preventDefault();
        let cursor = e.target.dataset.id;
        if (!cursor) return
        if (!Util.shareRedirect()) return;
        const { ResData, updateNavData } = this.props;
        updateNavData({
            navCursor: cursor
        });
        if(cursor == 'res' && !ResData.list.length && !ResData.isEnd) {
            // 拉`回复`的初始数据
            this.fetchResponseData();
            // 打点
            LXAnalytics('moduleClick', 'b_zsa2izig');
        } else if (cursor == 'detail' && !this.state.inputHidden){
            // 收起`input`
            this.inputStatusToggle();
        }
    }

    scrollLoadHandle(e) {
        e.preventDefault();
        // 说明：两个tab内容的滚动容器相同，`硬编码`判断当前内容是否可见
        if (this.props.NavData.navCursor != 'res') return;
        const {isError, isEnd, loading} = this.props.ResData;
        // conditions
        if (loading) {
            return;
        } else if (isEnd || isError) {
            this.scrollContainer.removeEventListener('scroll', this._scrollLoadHandler);
            // this._scrollLoadHandler = undefined; // 说明：`reset`可以用于重新初始化`scroll`事件
            return;
        }
        setTimeout(() => {
            const {scrollHeight, scrollTop, clientHeight} = this.scrollContainer;
            if (scrollTop) {
                // 可滚动容器
                if (scrollHeight - scrollTop - clientHeight <= MAXPRELOADHEIGHT) {
                    // console.log('scrollHeight/scrollTop/clientHeight', scrollHeight, scrollTop, clientHeight)
                    this.fetchResponseData();
                }
            } else {
                // 不可滚动容器以视窗为准
                // const { bottom } = this.scrollContainer.getBoundingClientRect();
                // const distanceFromBottom = bottom - this._getViewPort().height;
                // if (-1 <= distanceFromBottom && distanceFromBottom < MAXPRELOADHEIGHT) { // HACK: 部分机器拉到底部可能会出现负数
                //     this.fetchResponseData();
                // }
            }
        }, 0);
    }

    fetchResponseData() {
        const { ResData, fetchResData } = this.props;
        const page = parseInt(ResData.page) || 0;
        fetchResData('/mobile/event/ajax/statics/activity/followList', {
            offlineActivityId: this.offlineActivityId,
            page: page + 1
        }, 'GET', (r) => {
            return r.data.curPage == page + 1
        }).then((r) => {
        }).catch((e) => {
            console.log('Exceptioon', e)
        })
    }

    fetchUserData() {
        const {UserData, fetchUsersData} = this.props;
        const {page, isEnd, isError, loading} = UserData;
        if (isEnd || isError || loading) return
        if (page >= 1 && !Util.shareRedirect()) return;
        fetchUsersData('/activity/static/detail/releasedUsers', {
            offlineActivityId: this.offlineActivityId,
            page: page + 1
        }, 'POST', (r) => {
            return r.data.page == page + 1
        }).then((r) => {
        }).catch((e) => {
            console.log('Exception', e)
        });
    }

    btnClickHandle(e) {
        if (!Util.shareRedirect()) return;
        const {mode, userApplyStatus, loginStatus, moreActivityUrl, applyURL} = this.props.DetailData
        // 暂时统一在当前webview打开
        if(userApplyStatus && mode != 11) { // 说明：DB竞拍可以一直拍
            // 已报名/结束/中奖
            LXAnalytics('moduleClick', 'b_y5o23cfa');
            if(mode == 13 && userApplyStatus == 5){
                //天天抽邀请好友
                location.href = applyURL.replace('apply/', 'success/') + '&fromdetail=1'
            }else if(mode == 13 && userApplyStatus == 4){
	            location.href = applyURL
            }else{
	            location.href = moreActivityUrl;
            }
        } else if(loginStatus) {
            // 未报名
            location.href = applyURL;
        } else {
            // 未登录
            if (Util.isApp()) {
                Util.getToken().then(() => { // 说明：APP中登录成功后，需要手动获取登录态，因为页面无刷新
                    location.href = applyURL;
                }, () => {
                    Login(() => {
                        location.href = applyURL;
                    })
                }).catch((e) => {
                    console.log('Exception', e)
                })
            } else {
                Login()
            }
        }
    }

    inputStatusToggle() {
        if (!this.props.DetailData.loginStatus && Util.isApp()) {
            // APP中需要手动拿登录态
            return Util.getToken().then(() => {
                this.setState({
                    inputHidden: !this.state.inputHidden,
                })
                setTimeout(() => {
                    this.state.inputHidden || this.inputRef.focus();
                }, 0);
            }, () => {
                Login(() => {
                    this.inputStatusToggle();
                });
            })
        } else if (!this.props.DetailData.loginStatus) {
            // M站
            return Login();
        }
        this.setState({
            inputHidden: !this.state.inputHidden,
        })
        setTimeout(() => {
            this.state.inputHidden || this.inputRef.focus();
        }, 0);
    }

    inputFocusEvt(e) {
        e.preventDefault();
        this.originScrollTop = document.body.scrollTop; // 失焦重置scrollTop
        // document.body.scrollTop = document.body.scrollHeight;
        this.interval = setInterval(() => { // FIXME: 键盘切换
            document.body.scrollTop = document.body.scrollHeight;
        }, 100);
    }

    inputBlurEvt(e) {
        e.preventDefault();
        document.body.scrollTop = this.originScrollTop;
        clearInterval(this.interval);
    }

    inputSubmitHandle(e) {
        e.preventDefault();
        let content = this.inputRef.value.trim();
        if (!content || this.isSubmitting) return;
        this.isSubmitting = true; // 仅用来表示提交状态，与UI无关
        Util.reqwest('/activity/static/follow/add', {
            offlineActivityId: this.offlineActivityId,
            noteBody: content
        }, 'POST').then((r) => {
            // TODO: 新增`回应`展示逻辑
            if (r.code != 200 || !r.data) {
                return Toast('出错了')
            }
            const {addResData} = this.props;
            addResData({
                noteBody: r.data.noteBody || content,
                userNickName: r.data.userNickName || '点评用户',
                userFace: r.data.userFace,
                addDate: FormatDate(r.data.addTime, 'MM-dd HH:mm', '-')
            })
            this.inputStatusToggle(); // 关闭`input`
            this.inputRef.value = ''; // 提交成功，清空`input`
            this.isSubmitting = false; // reset 状态
        }).catch((e) => {
            console.log('Exception', e)
        })
    }
}

const formatDetailData = createSelector(
    [state => state.DetailData],
    (detailData) => {
        const fields = ['activityTips', 'winTips', 'activityContent', 'activityExplain', 'kindTips']
        fields.map((field) => {
            typeof detailData[field] == 'string' && (detailData[field] = detailData[field].split('\r\n'))
        })
        return detailData
    }
)

export default connect(
    (state) => {
        return {
            DetailData: formatDetailData(state),
            NavData: state.NavData,
            ResData: state.ResData,
            UserData: state.UserData
        }
    },
    {...Action}
)(Index);



// WEBPACK FOOTER //
// ./src/pages/detail.jsx